import React, { ReactNode } from 'react'

import { Wrapper, WrapperProps } from './Wrapper'

type RevealerProps = WrapperProps & {
    multi?: {
        delay: number
    }
    children: ReactNode
}

const Revealer = (props: RevealerProps): JSX.Element => {
    const { multi, children, ...rest } = props

    if (multi && Array.isArray(children)) {
        return (
            <>
                {children.map((el: ReactNode, index: number) => {
                    return (
                        <Wrapper {...rest} delay={multi.delay * index} key={`revealer-${index}`}>
                            {el}
                        </Wrapper>
                    )
                })}
            </>
        )
    }

    return <Wrapper {...rest}>{children}</Wrapper>
}

export { Revealer }
